import * as NotificationHelper from 'helpers/notificationHelper';
import { Config } from './callApi.types';

export const callApi = async <Payload = any>({
  action,
  onSuccess,
  onFailure = () => NotificationHelper.error('Request failed. Refresh page'),
  onCatch = () => NotificationHelper.error('Ooops... Something went wrong. Refresh page'),
}: Config<Payload>) => {
  try {
    const response = await action();

    if (typeof response !== 'undefined' && response.error === true) {
      if (typeof onFailure === 'function') {
        return onFailure(response);
      }

      return undefined;
    }

    if (typeof onSuccess === 'function') {
      return onSuccess(response);
    }
  } catch (e) {
    if (onCatch) {
      onCatch(e);
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }

  return undefined;
};
